import type { UseFormReturn } from "react-hook-form";
import type { FormSubmit } from "@shared-kernel/primary/shared/api-errors/action-form";
import type { FormInputs } from "./form-validation/user-reset-password.schema";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import { ArrowBigLeft } from "lucide-react";
import { ThemedButton } from "@shared-kernel/primary/shared/themed-button/themed-button";

interface Props {
  form: UseFormReturn<FormInputs>;
  onSubmit: FormSubmit;
  onBack: () => void;
}

const ResetForm = ({ form: methods, onSubmit, onBack }: Props) => {
  const {
    formState: { isDirty },
  } = methods;

  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} className="w-full">
        <div className="space-y-2">
          <FormField
            control={methods.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email</FormLabel>
                <FormControl>
                  <Input {...field} type="email" />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="flex items-center justify-between gap-x-2">
            <div onClick={onBack} role="button" className="flex items-center justify-between hover:font-semibold">
              <ArrowBigLeft />
              <span>Retour</span>
            </div>
            <ThemedButton isDirty={isDirty} label="Soumettre" />
          </div>
        </div>
      </form>
    </Form>
  );
};

export default ResetForm;
